/* Gensō Motors — Night Runners theme JS (vanilla, no jQuery) */
(function () {
  'use strict';

  /* ---------- sticky header: solid on scroll ---------- */
  var header = document.querySelector('[data-site-header]');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 40);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- mobile drawer ---------- */
  var drawer = document.querySelector('[data-nav-drawer]');
  var scrim = document.querySelector('.genso-drawer__scrim');
  function setDrawer(open) {
    if (!drawer) return;
    if (open && typeof setSearch === 'function') setSearch(false);
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (scrim) scrim.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    document.body.classList.toggle('nav-open', open);
    // Top scroller (back-to-top) only appears while the mobile menu is open, mobile only.
    var totop = document.querySelector('[data-totop]');
    if (totop) totop.classList.toggle('is-visible', open && window.matchMedia('(max-width: 768px)').matches);
    document.querySelectorAll('[data-nav-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-nav-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setDrawer(!drawer.classList.contains('is-open'));
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setDrawer(false);
  });

  /* ---------- search dropdown (replaces the standalone search page) ---------- */
  var searchDrop = document.querySelector('[data-search-dropdown]');
  var searchInput = searchDrop ? searchDrop.querySelector('[data-search-input]') : null;
  var searchResults = searchDrop ? searchDrop.querySelector('[data-search-results]') : null;
  var searchAll = searchDrop ? searchDrop.querySelector('[data-search-count]') : null;
  function setSearch(open) {
    if (!searchDrop) return;
    if (open) setDrawer(false);
    searchDrop.classList.toggle('is-open', open);
    searchDrop.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (open && searchInput) setTimeout(function () { searchInput.focus(); }, 60);
  }
  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      setSearch(!searchDrop.classList.contains('is-open'));
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setSearch(false);
  });
  document.addEventListener('click', function (e) {
    if (!searchDrop || !searchDrop.classList.contains('is-open')) return;
    if (e.target.closest('[data-search-dropdown]') || e.target.closest('[data-search-toggle]')) return;
    setSearch(false);
  });

  /* ---------- search dropdown: live predictive results ---------- */
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function clearSearchResults() {
    if (searchResults) searchResults.innerHTML = '';
    if (searchAll) searchAll.hidden = true;
  }
  function renderSearchResults(products, q) {
    if (!searchResults) return;
    if (!products.length) {
      searchResults.innerHTML = '<p class="genso-searchdrop__empty">Nothing. Zero. The night kept its secrets.</p>';
    } else {
      searchResults.innerHTML = products.map(function (p) {
        var img = (p.featured_image && p.featured_image.url)
          ? '<img src="' + escapeHtml(p.featured_image.url) + '" alt="" loading="lazy">'
          : '';
        var price = '$' + parseFloat(p.price).toFixed(2);
        return '<a class="genso-searchdrop__item" href="' + escapeHtml(p.url) + '">' +
          '<span class="genso-searchdrop__thumb">' + img + '</span>' +
          '<span class="genso-searchdrop__meta"><span class="genso-searchdrop__title">' + escapeHtml(p.title) + '</span>' +
          '<span class="genso-searchdrop__price">' + price + '</span></span></a>';
      }).join('');
    }
    if (searchAll) {
      searchAll.innerHTML = '<a href="/search?q=' + encodeURIComponent(q) + '&type=product">View all results &rarr;</a>';
      searchAll.hidden = false;
    }
  }
  var searchTimer = null;
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) { clearSearchResults(); return; }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            renderSearchResults(products, q);
          })
          .catch(clearSearchResults);
      }, 250);
    });
  }

  /* ---------- seamless marquee: duplicate track content ---------- */
  document.querySelectorAll('[data-marquee-track]').forEach(function (track) {
    var chunk = track.querySelector('.marquee__chunk');
    if (!chunk) return;
    // Duplicate until the track is at least 2x the viewport, then rely on -50% loop
    var guard = 0;
    while (track.scrollWidth < window.innerWidth * 2 && guard < 8) {
      track.appendChild(chunk.cloneNode(true));
      guard++;
    }
  });

  /* ---------- announcement dismissal + header offset ---------- */
  function setAnnounceHeight() {
    var bar = document.querySelector('[data-announcement]:not(.is-hidden)');
    var h = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--genso-announce-h', h + 'px');
  }
  setAnnounceHeight();
  window.addEventListener('resize', setAnnounceHeight);
  window.addEventListener('load', setAnnounceHeight);
  document.querySelectorAll('[data-announcement-dismiss]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var bar = btn.closest('[data-announcement]');
      if (bar) bar.classList.add('is-hidden');
      setAnnounceHeight();
    });
  });

  /* ---------- quantity steppers ---------- */
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('[data-qty-input]');
    if (!input) return;
    stepper.querySelector('[data-qty-minus]').addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(parseInt(input.min || '1', 10), v - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    stepper.querySelector('[data-qty-plus]').addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- cart count refresh ---------- */
  function refreshCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-hidden', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }
  /* shared namespace so the mobile-UX module can reuse the cart refresh */
  window.GensoMobile = window.GensoMobile || {};
  window.GensoMobile.refreshCartCount = refreshCartCount;

  /* ---------- quick add on product cards ---------- */
  document.querySelectorAll('[data-quickadd]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        body: data
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          refreshCartCount();
          var btn = form.querySelector('button[type="submit"]');
          var original = btn.textContent;
          btn.textContent = 'ADDED';
          setTimeout(function () { btn.textContent = original; }, 1200);
        })
        .catch(function () {});
    });
  });

  /* ---------- product page: thumbnails + variant pills ---------- */
  var productSection = document.querySelector('[data-product-section]');
  if (productSection) {
    var mainImg = productSection.querySelector('[data-product-main-image]');
    productSection.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full && mainImg) {
          mainImg.src = full;
          mainImg.srcset = full;
        }
        productSection.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });

    var form = productSection.querySelector('form.genso-product__form') || productSection.querySelector('[data-product-form]');
    if (form) {
      /* Variant data is embedded in the page, so the hidden id input updates
         synchronously with every pill change (no network round-trip). */
      var variantsData = [];
      try {
        var variantsJsonEl = productSection.querySelector('[data-variants-json]');
        variantsData = variantsJsonEl ? JSON.parse(variantsJsonEl.textContent) : [];
      } catch (e) { variantsData = []; }
      function checkedOptions() {
        var checked = [];
        form.querySelectorAll('fieldset.option-field').forEach(function (fs) {
          var sel = fs.querySelector('input[type="radio"]:checked');
          if (sel) checked.push(sel.value);
        });
        return checked;
      }
      function findVariantByOptions(checked) {
        for (var i = 0; i < variantsData.length; i++) {
          var v = variantsData[i];
          if (v.options && v.options.length === checked.length &&
              v.options.every(function (opt, j) { return opt === checked[j]; })) {
            return v;
          }
        }
        return null;
      }
      /* last-second guarantee: hidden id always mirrors the checked pills */
      function syncVariantId() {
        var m = findVariantByOptions(checkedOptions());
        var idInput = form.querySelector('[data-variant-id]');
        if (m && idInput) idInput.value = m.id;
        return m;
      }
      function applyVariant(match) {
        if (!match) return;
        var idInput = form.querySelector('[data-variant-id]');
        if (idInput) idInput.value = match.id;
        form.querySelectorAll('.option-pill').forEach(function (pill) {
          var radio = pill.querySelector('input');
          pill.classList.toggle('is-selected', !!(radio && radio.checked));
        });
        var priceWrap = productSection.querySelector('[data-product-price]');
        if (priceWrap) {
          var money = function (cents) {
            return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
          };
          var html = '<span class="price">' + money(match.price) + '</span>';
          if (match.compare_at_price && match.compare_at_price > match.price) {
            html = '<span class="price price--compare">' + money(match.compare_at_price) + '</span>' + html;
          }
          priceWrap.innerHTML = html;
        }
        var addBtn = form.querySelector('[data-add-to-cart]');
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? 'Add to cart' : 'SOLD OUT';
        }
        /* mobile-UX hook: keep the sticky add-to-cart bar in sync */
        if (window.GensoMobile && window.GensoMobile.onVariantChange) {
          window.GensoMobile.onVariantChange(match);
        }
      }
      var optionInputs = form.querySelectorAll('[data-variant-options] input[type="radio"]');
      if (optionInputs.length) {
        optionInputs.forEach(function (input) {
          input.addEventListener('change', function () {
            applyVariant(findVariantByOptions(checkedOptions()));
          });
        });
      }
      /* prevent double-submit on the main Add to Cart */
      form.addEventListener('submit', function () {
        syncVariantId();
        var btn = form.querySelector('[data-add-to-cart]');
        if (btn && !btn.disabled) {
          btn.disabled = true;
          btn.textContent = 'ADDING...';
        }
      });
    }
  }

  /* ---------- cart page: quantity change via AJAX ---------- */
  var cartSection = document.querySelector('[data-cart-section]');
  if (cartSection) {
    cartSection.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        var line = input.closest('[data-cart-line]');
        var key = line.getAttribute('data-key');
        var qty = parseInt(input.value, 10) || 0;
        var body = new FormData();
        body.append('id', key);
        body.append('quantity', qty);
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          body: body
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            refreshCartCount();
            if (qty === 0 && line) line.remove();
            var sub = cartSection.querySelector('[data-cart-subtotal]');
            if (sub) sub.textContent = (cart.total_price / 100).toLocaleString(undefined, { style: 'currency', currency: cart.currency });
            if (cart.item_count === 0) window.location.reload();
          })
          .catch(function () { window.location.reload(); });
      });
    });
    cartSection.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.closest('[data-cart-line]');
        var input = line.querySelector('[data-cart-qty]');
        input.value = 0;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- collection sort dropdown ---------- */
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      select.closest('form').submit();
    });
  });
})();

/* ============================================================
   SAKURA EDITION — entrance, petals, scroll reveal, parallax
   (lightweight; fully skipped under prefers-reduced-motion)
   ============================================================ */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('genso-js');

  /* ---------- hero staggered entrance ---------- */
  var hero = document.querySelector('[data-hero]');
  if (hero) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { hero.classList.add('is-loaded'); });
    });
  }

  /* ---------- falling sakura petals over the hero ---------- */
  var canvas = document.querySelector('[data-petals]');
  if (canvas && hero && !reduced && canvas.getContext) {
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, running = true, inView = true;
    var PETAL_COUNT = 40;
    var petals = [];

    function sizeCanvas() {
      var r = hero.getBoundingClientRect();
      W = Math.max(1, r.width); H = Math.max(1, r.height);
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function makePetal(anywhere) {
      return {
        x: Math.random() * W,
        y: anywhere ? Math.random() * H : -20 - Math.random() * 40,
        w: 6 + Math.random() * 8,
        h: 4 + Math.random() * 6,
        vy: 0.4 + Math.random() * 1.1,
        swayAmp: 20 + Math.random() * 40,
        swaySpeed: 0.005 + Math.random() * 0.015,
        phase: Math.random() * Math.PI * 2,
        rot: Math.random() * Math.PI * 2,
        rotSpeed: (Math.random() - 0.5) * 0.03,
        alpha: 0.35 + Math.random() * 0.45,
        hue: Math.random() < 0.5 ? '240,166,198' : '233,139,180'
      };
    }
    function draw(p, t) {
      var sway = Math.sin(t * p.swaySpeed + p.phase) * p.swayAmp;
      ctx.save();
      ctx.translate(p.x + sway, p.y);
      ctx.rotate(p.rot);
      ctx.globalAlpha = p.alpha;
      ctx.fillStyle = 'rgb(' + p.hue + ')';
      ctx.beginPath();
      ctx.ellipse(0, 0, p.w / 2, p.h / 2, 0.5, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    }
    function tick(t) {
      if (!running) return;
      if (inView) {
        ctx.clearRect(0, 0, W, H);
        for (var i = 0; i < petals.length; i++) {
          var p = petals[i];
          p.y += p.vy;
          p.rot += p.rotSpeed;
          if (p.y > H + 30) p = petals[i] = makePetal(false);
          draw(p, t || 0);
        }
      }
      requestAnimationFrame(tick);
    }
    function reset() {
      sizeCanvas();
      petals = [];
      for (var i = 0; i < PETAL_COUNT; i++) petals.push(makePetal(true));
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
      }).observe(hero);
    }
    document.addEventListener('visibilitychange', function () {
      running = !document.hidden;
      if (running) requestAnimationFrame(tick);
    });
    window.addEventListener('resize', sizeCanvas);
    reset();
    requestAnimationFrame(tick);
  }

  /* ---------- scroll reveal ---------- */
  var revealTargets = document.querySelectorAll(
    '.genso-section, .product-card, .genso-lookbook__item, .genso-womens__media, .genso-womens__copy'
  );
  if ('IntersectionObserver' in window && !reduced) {
    Array.prototype.forEach.call(revealTargets, function (el) { el.classList.add('reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(revealTargets, function (el) { io.observe(el); });
  }

  /* ---------- subtle hero background parallax ---------- */
  var heroMedia = hero ? hero.querySelector('.genso-hero__media') : null;
  if (hero && heroMedia && !reduced) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y < window.innerHeight * 1.2) {
          heroMedia.style.transform = 'translateY(' + (y * 0.25) + 'px)';
        }
        ticking = false;
      });
    }, { passive: true });
  }
})();

/* ============================================================
   MOBILE UX — sticky ATC bar, bottom nav, swipeable gallery,
   filter drawer, back-to-top (vanilla; mobile gated to 768px)
   ============================================================ */
(function () {
  'use strict';
  window.GensoMobile = window.GensoMobile || {};
  var mq = window.matchMedia('(max-width: 768px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function isMobile() { return mq.matches; }

  var productSection = document.querySelector('[data-product-section]');
  var stickyBar = document.querySelector('[data-sticky-atc]');

  /* ---------- sticky add-to-cart bar (product pages) ---------- */
  if (stickyBar && productSection) {
    var buyRow = productSection.querySelector('.genso-product__buy-row');
    var mainForm = productSection.querySelector('form.genso-product__form') || productSection.querySelector('[data-product-form]');
    var stickyPrice = stickyBar.querySelector('[data-sticky-atc-price]');
    var stickySelect = stickyBar.querySelector('[data-sticky-atc-variant]');
    var stickyAdd = stickyBar.querySelector('[data-sticky-atc-add]');
    var variants = [];
    try {
      var jsonEl = productSection.querySelector('[data-variants-json]');
      variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    } catch (e) { variants = []; }

    function money(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
    }
    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }
    function setBarVisible(visible) {
      stickyBar.classList.toggle('is-visible', visible);
      stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      /* hide the bottom nav while the bar is up so they never stack */
      document.body.classList.toggle('has-sticky-atc', visible);
    }
    function updateBarFromVariant(variant) {
      if (!variant) return;
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (stickySelect && String(stickySelect.value) !== String(variant.id)) {
        stickySelect.value = variant.id;
      }
      if (stickyAdd) {
        stickyAdd.disabled = !variant.available;
        stickyAdd.textContent = variant.available ? 'ADD' : 'SOLD OUT';
      }
    }
    /* called by the existing variant-pill change handler via hook */
    window.GensoMobile.onVariantChange = function (match) { updateBarFromVariant(match); };

    /* sticky select -> sync the main form's radios (fires existing logic once) */
    if (stickySelect) {
      stickySelect.addEventListener('change', function () {
        var variant = findVariant(stickySelect.value);
        if (!variant || !mainForm) return;
        var idInput = mainForm.querySelector('[data-variant-id]');
        if (idInput) idInput.value = variant.id;
        var fieldsets = mainForm.querySelectorAll('fieldset.option-field');
        var toFire = null;
        Array.prototype.forEach.call(fieldsets, function (fs, i) {
          var target = variant.options ? variant.options[i] : null;
          if (target == null) return;
          Array.prototype.forEach.call(fs.querySelectorAll('input[type="radio"]'), function (r) {
            if (r.value === target && !r.checked) { r.checked = true; toFire = r; }
            var pill = r.closest('.option-pill');
            if (pill) pill.classList.toggle('is-selected', r.checked);
          });
        });
        if (toFire) {
          toFire.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          updateBarFromVariant(variant);
        }
      });
    }

    /* sticky add -> AJAX to /cart/add.js, reuse cart count refresh */
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var idInput = mainForm ? mainForm.querySelector('[data-variant-id]') : null;
        var id = idInput ? idInput.value : (stickySelect ? stickySelect.value : null);
        if (!id || stickyAdd.disabled) return;
        var data = new FormData();
        data.append('id', id);
        data.append('quantity', '1');
        stickyAdd.disabled = true;
        fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: data })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            if (window.GensoMobile.refreshCartCount) window.GensoMobile.refreshCartCount();
            stickyAdd.textContent = 'ADDED';
            setTimeout(function () { updateBarFromVariant(findVariant(id)); }, 1200);
          })
          .catch(function () {
            var v = findVariant(id);
            stickyAdd.disabled = v ? !v.available : false;
          });
      });
    }

    /* show the bar once the main buy row scrolls out of view */
    if ('IntersectionObserver' in window && buyRow) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        setBarVisible(isMobile() && past);
      }, { threshold: 0 }).observe(buyRow);
    }
    if (mq.addEventListener) {
      mq.addEventListener('change', function () {
        if (!isMobile()) setBarVisible(false);
      });
    }
  }

  /* ---------- swipeable gallery: dots + lightbox (product pages) ---------- */
  var carousel = document.querySelector('[data-product-carousel]');
  if (carousel && productSection) {
    var slides = carousel.querySelectorAll('[data-slide]');
    var dotsWrap = productSection.querySelector('[data-carousel-dots]');
    var dots = [];
    if (dotsWrap) {
      Array.prototype.forEach.call(slides, function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'genso-product__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
        dot.addEventListener('click', function () {
          carousel.scrollTo({ left: slide.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }
    function setActiveDot() {
      var w = carousel.clientWidth || 1;
      var idx = Math.round(carousel.scrollLeft / w);
      idx = Math.max(0, Math.min(dots.length - 1, idx));
      Array.prototype.forEach.call(dots, function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }
    var scrollT = null;
    carousel.addEventListener('scroll', function () {
      if (scrollT) return;
      scrollT = setTimeout(function () { scrollT = null; setActiveDot(); }, 80);
    }, { passive: true });

    var lightbox = document.querySelector('[data-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('[data-lightbox-img]') : null;
    function openLightbox(src, alt) {
      if (!lightbox || !lightboxImg || !isMobile()) return;
      lightboxImg.src = src;
      lightboxImg.alt = alt || '';
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lightboxImg) lightboxImg.src = '';
    }
    /* Tap vs. swipe: open the lightbox only on a genuine tap, never after a swipe
       gesture. Delegated on the carousel so it keeps working if slides re-render. */
    var tapStartX = 0, tapStartY = 0, tapMoved = false;
    carousel.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      tapStartX = t.clientX; tapStartY = t.clientY; tapMoved = false;
    }, { passive: true });
    carousel.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      if (Math.abs(t.clientX - tapStartX) > 12 || Math.abs(t.clientY - tapStartY) > 12) tapMoved = true;
    }, { passive: true });
    carousel.addEventListener('click', function (e) {
      var target = e.target && e.target.closest ? e.target.closest('[data-slide]') : null;
      if (!target || !carousel.contains(target)) return;
      var wasSwipe = tapMoved;
      tapMoved = false;
      if (wasSwipe) return;
      openLightbox(target.getAttribute('data-full'), target.getAttribute('aria-label'));
    });
    if (lightbox) {
      lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (btn) {
        btn.addEventListener('click', closeLightbox);
      });
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
      });
    }
  }

  /* ---------- collection filter & sort drawer ---------- */
  var filterDrawer = document.querySelector('[data-filter-drawer]');
  if (filterDrawer) {
    var filterScrim = document.querySelector('.genso-filter-scrim');
    function setFilter(open) {
      filterDrawer.classList.toggle('is-open', open);
      filterDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (filterScrim) filterScrim.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }
    document.querySelectorAll('[data-filter-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { setFilter(true); });
    });
    document.querySelectorAll('[data-filter-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { setFilter(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && filterDrawer.classList.contains('is-open')) setFilter(false);
    });
    var sortForm = document.querySelector('[data-sort-form]');
    var sortSelect = document.querySelector('[data-sort-select]');
    filterDrawer.querySelectorAll('[data-sort-value]').forEach(function (row) {
      row.addEventListener('click', function () {
        var val = row.getAttribute('data-sort-value');
        if (sortSelect) sortSelect.value = val;
        setFilter(false);
        if (sortForm) sortForm.submit();
      });
    });
  }

  /* ---------- back to top (mobile only; visible only while the mobile menu is open) ---------- */
  var totop = document.querySelector('[data-totop]');
  if (totop) {
    // Visibility is driven by the nav drawer (see setDrawer above): the
    // button only appears when the mobile menu pops up, mobile only.
    function syncTotop() {
      totop.classList.toggle('is-visible',
        isMobile() && document.body.classList.contains('nav-open'));
    }
    window.addEventListener('resize', syncTotop);
    syncTotop();
    totop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });
  }
})();
